/*
 * miss ysa - cart drawer (AJAX). Bez przeladowania strony.
 * cart.js + Section Rendering API. Globalny obiekt window.MissYsaCart.
 * Otwiera sie po add to cart i po kliknieciu bag w headerze.
 */
(function () {
  var SECTION_ID = 'missysa-cart-drawer';
  var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function sectionEl() {
    return document.getElementById('shopify-section-' + SECTION_ID);
  }
  function drawerRoot() {
    return document.querySelector('[data-ms-cart-drawer]');
  }

  function setBusy(busy) {
    var root = drawerRoot();
    if (root) root.setAttribute('data-busy', busy ? 'true' : 'false');
  }

  function updateBadges() {
    var root = drawerRoot();
    if (!root) return;
    var count = parseInt(root.getAttribute('data-cart-count') || '0', 10);
    document.querySelectorAll('[data-ms-cart-count]').forEach(function (b) {
      b.textContent = count;
      b.hidden = count === 0;
    });
  }

  function open() {
    document.body.classList.add('ms-cart-open');
    var root = drawerRoot();
    if (root) root.setAttribute('aria-hidden', 'false');
  }
  function close() {
    document.body.classList.remove('ms-cart-open');
    var root = drawerRoot();
    if (root) root.setAttribute('aria-hidden', 'true');
  }

  function refresh() {
    return fetch(routesRoot + '?sections=' + SECTION_ID, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION_ID];
        var host = sectionEl();
        if (host && typeof html === 'string') {
          host.innerHTML = html;
        }
        updateBadges();
      });
  }

  function flashError(msg) {
    var box = document.querySelector('[data-ms-cart-error]');
    if (box) {
      box.textContent = msg || '';
      box.hidden = !msg;
    }
  }

  function addFromForm(form, btn) {
    var data = new FormData(form);
    var label = btn ? btn.querySelector('[data-ms-add-text]') : null;
    var prev = label ? label.textContent : '';
    if (btn) btn.disabled = true;
    if (label) label.textContent = '...';
    flashError('');

    fetch(routesRoot + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: data
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () { return refresh(); })
      .then(function () { open(); })
      .catch(function (err) {
        flashError((err && err.description) || 'Nie udalo sie dodac do koszyka.');
      })
      .finally(function () {
        if (btn) btn.disabled = false;
        if (label) label.textContent = prev;
      });
  }

  function add(variantId, quantity) {
    flashError('');
    return fetch(routesRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () { return refresh(); })
      .then(function () { open(); });
  }

  function buyNow(variantId, quantity) {
    return fetch(routesRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () { window.location.href = routesRoot + 'checkout'; });
  }

  function changeLine(line, quantity) {
    setBusy(true);
    return fetch(routesRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .finally(function () { setBusy(false); });
  }

  function updateNote(note) {
    return fetch(routesRoot + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ note: note })
    });
  }

  function applyDiscount(code) {
    setBusy(true);
    flashError('');
    return fetch(routesRoot + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(routesRoot + 'cart.js'), {
      headers: { Accept: 'application/json' }
    })
      .then(function () { return refresh(); })
      .finally(function () { setBusy(false); });
  }

  /* ----- Event delegation (przetrwa podmiane innerHTML sekcji) ----- */
  document.addEventListener('click', function (e) {
    var openEl = e.target.closest('[data-ms-cart-open]');
    if (openEl) { e.preventDefault(); open(); return; }

    var closeEl = e.target.closest('[data-ms-cart-close]');
    if (closeEl) { e.preventDefault(); close(); return; }

    var inc = e.target.closest('[data-ms-qty-inc]');
    if (inc) { e.preventDefault(); changeLine(parseInt(inc.getAttribute('data-line'), 10), parseInt(inc.getAttribute('data-qty'), 10) + 1); return; }

    var dec = e.target.closest('[data-ms-qty-dec]');
    if (dec) { e.preventDefault(); changeLine(parseInt(dec.getAttribute('data-line'), 10), Math.max(0, parseInt(dec.getAttribute('data-qty'), 10) - 1)); return; }

    var rm = e.target.closest('[data-ms-remove]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.getAttribute('data-line'), 10), 0); return; }

    var applyEl = e.target.closest('[data-ms-discount-apply]');
    if (applyEl) {
      e.preventDefault();
      var input = document.querySelector('[data-ms-discount-input]');
      if (input && input.value.trim()) applyDiscount(input.value.trim());
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('ms-cart-open')) close();
  });

  /* Add note: zapisz przy zmianie (debounce) */
  var noteTimer = null;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-ms-note]');
    if (note) {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () { updateNote(note.value); }, 500);
    }
  });

  window.MissYsaCart = {
    open: open,
    close: close,
    refresh: refresh,
    add: add,
    addFromForm: addFromForm,
    buyNow: buyNow,
    changeLine: changeLine,
    applyDiscount: applyDiscount
  };

  document.addEventListener('DOMContentLoaded', updateBadges);
})();
